import { useRouter } from "next/router";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const CoreLayout = ({ children }: Props) => {
  const router = useRouter();
  return (
    <main>
      {router.isPreview && <div id="preview-mode-banner" />}
      {children}
    </main>
  );
};

export default CoreLayout;
